This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="basicBlock settingsBlock">
    <p class="header upper">{{ $t("settings.game.header") }}</p>
    <div class="blockEntry buttonsRight">
      <p class="textWithToggle">
        {{ $t("settings.game.soundEffects") }}
      </p>
      <label class="toggle">
        <input
          type="checkbox"
          class="base"
          :checked="soundEnabled"
          @click="toggleSound()"
          autocomplete="off"
        />
        <div class="background"></div>
        <div class="button"></div>
      </label>
    </div>
    <div class="blockEntry buttonsRight">
      <p class="textWithToggle">
        {{ $t("settings.game.music") }}
      </p>
      <label class="toggle">
        <input
          type="checkbox"
          class="base"
          :checked="musicEnabled"
          @click="toggleMusic()"
          autocomplete="off"
        />
        <div class="background"></div>
        <div class="button"></div>
      </label>
    </div>
    <div class="buttonsCenter spaceAbove">
      <button
        class="button success save"
        @click="
          updateStore();
          updateDatabase();
          updateLocalStorage();
        "
      >
        {{ $t("settings.saveButton") }}
        <div v-if="savedSetting == 'succeeded'" class="image">
          <img src="@/assets/images/icons/Check.svg" alt="Save success icon" />
        </div>
        <div v-else-if="savedSetting == 'failed'" class="image">
          <img src="@/assets/images/icons/Cross.svg" alt="Save failed icon" />
        </div>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { userAPI } from "@/utils/apiCalls";

@Options({
  data() {
    return {
      soundEnabled: false,
      musicEnabled: false,
      savedSetting: "",
    };
  },
  methods: {
    //Toggle sound on and off
    toggleSound(): void {
      this.soundEnabled = !this.soundEnabled;
    },
    //Toggle music on and off
    toggleMusic(): void {
      this.musicEnabled = !this.musicEnabled;
    },
    //Update store on music or sound update
    updateStore(): void {
      this.$store.commit("setSoundSettings", this.soundEnabled);
      this.$store.commit("setMusicSettings", this.musicEnabled);
    },
    //Update local storage on music or sound update
    updateLocalStorage(): void {
      localStorage.setItem(
        "userInfo",
        JSON.stringify(this.$store.getters.getUserInfo)
      );
    },
    //Update database on music or sound update
    updateDatabase(): void {
      let success: Promise<number | null>;
      success = userAPI.setUserPreferences(this.$store.getters.getPreferences);

      if (success !== null) {
        this.savedSetting = "succeeded";
      } else {
        this.savedSetting = "failed";
      }
      //Timer for the action success text
      setTimeout(() => {
        this.savedSetting = "";
      }, 5000);
    },
  },
  beforeMount() {
    //Set music and sound value
    this.soundEnabled = this.$store.getters.getPreferences.soundEnabled;
    this.musicEnabled = this.$store.getters.getPreferences.musicEnabled;
  },
})
export default class GameSettingsBlock extends Vue {}
</script>
